module.exports = __webpack_public_path__ + "650fe6f6cdb9736226bd617528726f2f.svg";